
import './App.css';import { BrowserRouter, Route, Routes , Navigate} from "react-router-dom";
import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import Footer from "./Components/Footer";
import StickyFooter from "./Components/StickyFooter";
import Thankyou from "./Pages/Thankyou";
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <div>
      <Toaster />
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thankyou" element={<Thankyou />} />
         <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
      <StickyFooter />
    </BrowserRouter>
    </div>
  );
}

export default App;
